import React from 'react'
import styled from '@emotion/styled'
import { Form, spacer } from 'stylist'
import IntegerInput from 'components/IntegerInput'

const SmallInput = styled(IntegerInput)`
  width: 100px;
  display: inline;
  margin-right: ${spacer(2)};
`

const FormGroup = styled(Form.Group)`
  margin-bottom: 0;
  position: relative;

  div[role='alert'] {
    position: absolute;
    z-index: 999;
    max-width: 90%;

    svg {
      min-width: 1.5rem;
    }
  }
`

const EstimateInput = ({ name, label, unit }) => (
  <FormGroup>
    {label ? <Form.Label htmlFor={name}>{label}</Form.Label> : null}
    <div>
      <SmallInput id={name} name={name} />
      <Form.Label htmlFor={name}>{unit}</Form.Label>
    </div>
  </FormGroup>
)

export default EstimateInput



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/form/EstimateInput.js